import React from 'react'
import { MuiGrid, MuiTypography, MuiToolTip, MuiShareIcon, MuiButton, MuiFormControl, MuiEmailIcon, MuiError, MuiRadioGroup, MuiFormControlLabel } from '../../../ui/MaterialUIComponents';

import PageHeaderComponent from '../../../ui/PageHeaderComponent'
import theme from '../../../../assests/theme';
import { makeStyles } from '@material-ui/core/styles';
import ShareTimeTableDialog from './ShareTimeTableDialog'
import { Radio } from '../../../ui/customUIComponents'
import GenerateTimeTableExcel from './GenerateTimeTableExcel'
import ExcelFileDownload from './ExcelFileDownload'
import ReactExport from "react-data-export";
import { MuiGetApp } from '../../../ui/MaterialUIComponents';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const useStyles = makeStyles(theme => ({
    root: { marginLeft: 8 },
    titleStyle: { color: theme.palette.primary.main, fontWeight: 600 },
    subTitleStyle: { color: theme.palette.primary.light },
    radioGroupListStyle: { width: '100%', margin: 0 },
    groupTitle: { color: theme.textColor, fontWeight: 600, paddingLeft: 2, paddingRight: 8 },
    groupAttributeTitle: { color: theme.textColor, fontWeight: 400 },
    iconStyle: { color: 'white', height: '30', width: '25px' },
    printIconStyle: { height: '30', width: '25px' },
    iconButtonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        },
        background: theme.palette.primary.main, width: '20px'
    },
    errorIconButtonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.error.light
        }, background: theme.palette.error.main, width: '20px'
    },
    iconDisabledButtonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.grey.light
        }, background: theme.palette.primary.light, width: '20px'
    },

    errorIconDisabledButtonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.grey.light
        }, background: theme.palette.error.light, width: '20px'
    }
}));
export default function TimeTableToolBar(props) {
    const i18n = props.i18n
    let radioGroupList = [{
        label: i18n.commonTexts.show.toUpperCase(),
        attributes: [{ value: 'forClass', label: i18n.weeklyTimeTable.forClass },
        { value: 'forTeacher', label: i18n.weeklyTimeTable.forTeacher },
        { value: 'forRooms', label: i18n.weeklyTimeTable.forRooms }],
        value: props.timeTableType,
        method: props.handleChangeTimeTableType

    }, {
        label: i18n.commonTexts.based.toUpperCase(),
        attributes: [{ value: 'masterSchedule', label: i18n.weeklyTimeTable.masterSchedule },
        { value: 'individualSchedule', label: i18n.weeklyTimeTable.individualSchedule }],
        value: props.scheduleType,
        method: props.handleChangeScheduleType

    },

        // {
        //     label: 'TIMETABLE FOR',
        //     attributes: props.calendars.length>1 && props.calendars.map(function(cal){
        //         return {value:cal.calendarName,label:cal.calendarName}
        //     }),
        //     value:props.calendars.length>0 &&   props.gradeLevel,
        //     method: props.handleChange

        // }
    ]
    const [openShareTimeTableDialog, setOpenShareTimeTableDialog] = React.useState(false);
    const classes = useStyles();
    const shareTimeTableDialog = () => {
        const { classes } = props

        return (

            <ShareTimeTableDialog {...props} schedule={props.schedule} cancel={cancel} open={openShareTimeTableDialog} />
        )
    }
    const showToolTipForErrors = () => {
        const i18n = props.i18n
        let data = i18n.log.errors + ' :' + ((props.schedule.errorLog.errorsCount != undefined) ? props.errorLog.errorsCount : 0) + ' , '
        data = data + (i18n.log.warnings + ' :' + ((props.schedule.errorLog.warningsCount != undefined) ? props.errorLog.warningsCount : 0))
        return data
    }
    const openShareTimeTableDialogMethod = event => {
        setOpenShareTimeTableDialog(prevOpen => !prevOpen);

    };
    const cancel = () => {
        setOpenShareTimeTableDialog(prevOpen => !prevOpen);
    }
    return (

        <MuiGrid container >
            <PageHeaderComponent {...props} title={props.i18n.weeklyTimeTable.title} subTitle={props.i18n.weeklyTimeTable.subTitle} />
            <MuiGrid container xs={12} className={classes.root}>
                {openShareTimeTableDialog ? shareTimeTableDialog() : null}
                <MuiGrid container xs className={classes.radioGroupListStyle} justify='center'>
                    {radioGroupList.map((group, index) =>
                        group.attributes.length > 0 &&
                        <MuiGrid container xs direction='row' style={{ border: "2px solid " + theme.palette.grey.main }} alignItems='center' justify='center'>
                            <MuiGrid item>
                                <MuiTypography variant={theme.typographyStyles.CAPTION} className={classes.groupTitle}> {group.label}</MuiTypography>
                            </MuiGrid>
                            <MuiGrid item
                            >

                                <MuiFormControl component="fieldset">

                                    <MuiRadioGroup aria-label="position" name="position" value={group.value} onChange={group.method} row>
                                        {group.attributes.map((attribute) =>
                                            <MuiFormControlLabel
                                                value={attribute.value}
                                                control={<Radio size='small' />}
                                                label={<MuiTypography variant={theme.typographyStyles.CAPTION}
                                                    className={classes.groupAttributeTitle}

                                                >  {attribute.label}</MuiTypography>}
                                                labelPlacement="end"
                                            />
                                        )}



                                    </MuiRadioGroup></MuiFormControl>
                            </MuiGrid></MuiGrid>)
                    }

                </MuiGrid>


                <MuiGrid container alignContent='center' justify='flex-start' xs={2} >

                    {/* {!props.displayError && */}

                    <MuiGrid item xs align='left' style={{ paddingLeft: 10 }}>
                        <MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{showToolTipForErrors()}</MuiTypography>} arrow  >
                            <MuiButton className={props.schedule.errorLog.errors.length == 0 ? classes.errorIconDisabledButtonStyle : classes.errorIconButtonStyle}
                                onClick={() => props.viewErrors(props.displayError)}
                            // disabled={props.schedule.errorLog.errors.length == 0}
                            >
                                <MuiError className={classes.iconStyle} />
                            </MuiButton>
                        </MuiToolTip>
                    </MuiGrid>

                    {(props.activeSchool.license.status !== 'Trial period' || (props.activeSchool.license.status === 'Trial period' && props.systemConfig.enableBlurForTrialUser==false)) ?
                        <MuiGrid item xs align='left'>
                            {props.dataSet.length > 0 ?
                                <ExcelFile element={
                                    <MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{props.i18n.weeklyTimeTable.downloadCSV}</MuiTypography>} arrow  >
                                        <MuiButton className={classes.iconButtonStyle}><MuiGetApp className={classes.iconStyle}></MuiGetApp></MuiButton>
                                    </MuiToolTip>
                                }>
                                    <ExcelSheet dataSet={props.dataSet} name={props.sheetName} />
                                </ExcelFile>
                                : <GenerateTimeTableExcel  {...props} />}  </MuiGrid> :
                        <MuiGrid item xs align='left'>
                            <MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}> {props.i18n.weeklyTimeTable.generateExcelToolTipForTrial} </MuiTypography>} arrow  >
                                <MuiButton className={classes.iconDisabledButtonStyle}><MuiGetApp className={classes.iconStyle}></MuiGetApp></MuiButton>
                            </MuiToolTip>
                        </MuiGrid>
                    }
                    {(props.activeSchool.license.status !== 'Trial period' || (props.activeSchool.license.status === 'Trial period' && props.systemConfig.enableBlurForTrialUser==false)) ?

                        <MuiGrid item xs align='left'>
                            <MuiButton className={classes.iconButtonStyle} onClick={openShareTimeTableDialogMethod}>
                                <MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}> {props.i18n.weeklyTimeTable.shareTimeTable} </MuiTypography>} arrow  >
                                    <MuiShareIcon className={classes.iconStyle} />
                                </MuiToolTip>
                            </MuiButton>
                        </MuiGrid> :

                        <MuiGrid item xs align='left'>
                            <MuiButton className={classes.iconDisabledButtonStyle} >
                                <MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.weeklyTimeTable.shareTimeTableToolTipForTrial}</MuiTypography>} arrow  >
                                    <MuiShareIcon className={classes.iconStyle} />
                                </MuiToolTip>
                            </MuiButton>
                        </MuiGrid>

                    }
                </MuiGrid>

            </MuiGrid></MuiGrid>


    )

}
